import { render, staticRenderFns } from "./unbindbank.vue?vue&type=template&id=af244cca&"
import script from "./unbindbank.vue?vue&type=script&lang=js&"
export * from "./unbindbank.vue?vue&type=script&lang=js&"
import style0 from "./unbindbank.vue?vue&type=style&index=0&id=af244cca&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports